import React, { useState } from "react";
import VictoryCard from "../components/VictoryCard";

// Demo page used to verify Victory Card image export on any device.
// Visit /demo/card to render a mock card without having to play 5 rounds.
const CardDemo = () => {
  const [team, setTeam] = useState("beef");
  const [won, setWon] = useState(true);
  return (
    <div className="min-h-screen bg-[color:var(--yellow)] p-4 flex flex-col items-center gap-4">
      <h1 className="font-display text-3xl title-3d-red mt-2">Victory Card · Export Test</h1>
      <div className="flex gap-3 flex-wrap justify-center">
        <button
          className="btn-fantastic yellow"
          onClick={() => setTeam(team === "beef" ? "chicken" : "beef")}
          data-testid="demo-toggle-team"
        >
          <span style={{ transform: "skewX(6deg)", display: "inline-block" }}>
            Team: {team}
          </span>
        </button>
        <button
          className="btn-fantastic yellow"
          onClick={() => setWon((v) => !v)}
          data-testid="demo-toggle-result"
        >
          <span style={{ transform: "skewX(6deg)", display: "inline-block" }}>
            Result: {won ? "VICTORY" : "DEFEATED"}
          </span>
        </button>
      </div>
      <VictoryCard
        username="Partner"
        playerTeam={team}
        won={won}
        foeLabel="The Outlaw"
        score="3-2"
        bestMs={248}
        avgMs={312}
      />
      <p className="font-elite text-xs text-[color:var(--deepest-brown)] max-w-md text-center mt-2">
        Tap "Save to Camera Roll" or "Share your Showdown" to verify the exported image renders with
        all characters and logos.
      </p>
    </div>
  );
};

export default CardDemo;
